// extracted by mini-css-extract-plugin
export default {"box":"style_box__1tZpb","boxContent":"style_boxContent__BzmxN"};